// Translation files
const translations = {
    ar: {
        login: {
            title: 'مرحباً بعودتك هنا!',
            email: 'البريد الإلكتروني',
            emailPlaceholder: 'example@email.com',
            emailRequired: 'البريد الإلكتروني مطلوب',
            emailInvalid: 'البريد الإلكتروني غير صحيح',
            password: 'كلمة المرور',
            passwordPlaceholder: '••••••••••••',
            passwordRequired: 'كلمة المرور مطلوبة',
            passwordMinLength: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
            rememberMe: 'تذكرني',
            forgotPassword: 'نسيت كلمة المرور',
            loginButton: 'تسجيل دخول',
            loginButtonLoading: 'جاري تسجيل الدخول...',
            noAccount: 'ليس لديك حساب ؟',
            createAccount: 'إنشاء حساب الآن',
            loginSuccess: 'تم تسجيل الدخول بنجاح!',
            loginError: 'فشل تسجيل الدخول',
            language: 'اللغة',
            switchToEnglish: 'English',
            switchToArabic: 'العربية',
        },
        register: {
            title: 'إنشاء حساب جديد',
            name: 'الاسم',
            namePlaceholder: 'أدخل اسمك الكامل',
            nameRequired: 'الاسم مطلوب',
            email: 'البريد الإلكتروني',
            emailPlaceholder: 'example@email.com',
            emailRequired: 'البريد الإلكتروني مطلوب',
            emailInvalid: 'البريد الإلكتروني غير صحيح',
            phone: 'رقم الهاتف',
            phoneRequired: 'رقم الهاتف مطلوب',
            password: 'كلمة المرور',
            passwordPlaceholder: '••••••••••••',
            passwordRequired: 'كلمة المرور مطلوبة',
            passwordMinLength: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
            confirmPassword: 'تأكيد كلمة المرور',
            confirmPasswordPlaceholder: '••••••••••••',
            confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
            confirmPasswordMismatch: 'كلمة المرور غير متطابقة',
            role: 'الدور',
            roleRequired: 'الدور مطلوب',
            roleEmployee: 'باحث عن عمل',
            roleCompany: 'شركة',
            roleRecruitmentCompany: 'شركة توظيف',
            registerButton: 'إنشاء حساب',
            registerButtonLoading: 'جاري إنشاء الحساب...',
            hasAccount: 'لديك حساب بالفعل؟',
            loginLink: 'تسجيل دخول',
            registerSuccess: 'تم إنشاء الحساب بنجاح!',
            registerSuccessVerify: 'تم إنشاء الحساب بنجاح! يرجى التحقق من البريد الإلكتروني.',
            registerError: 'فشل إنشاء الحساب',
        },
        verifyEmail: {
            verifyEmailTitle: 'التحقق من البريد الإلكتروني',
            verificationCodeSentToEmail: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني:',
            email: 'البريد الإلكتروني',
            emailPlaceholder: 'example@email.com',
            emailRequired: 'البريد الإلكتروني مطلوب',
            emailInvalid: 'البريد الإلكتروني غير صحيح',
            verificationCode: 'رمز التحقق',
            enterVerificationCode: 'يرجى إدخال رمز التحقق',
            emailNotFound: 'البريد الإلكتروني غير موجود',
            emailVerifiedSuccessfully: 'تم التحقق من البريد الإلكتروني بنجاح!',
            emailVerificationFailed: 'فشل التحقق من البريد الإلكتروني',
            resendVerificationCode: 'إعادة إرسال رمز التحقق',
            resendingVerificationCode: 'جاري إعادة الإرسال...',
            resendVerificationCodeSuccessfully: 'تم إعادة إرسال رمز التحقق بنجاح',
            resendVerificationCodeFailed: 'فشل إعادة إرسال رمز التحقق',
            verifyingCode: 'جاري التحقق...',
            verify: 'تحقق',
            didNotReceiveCode: 'لم تستلم الرمز؟',
            returnToLogin: 'العودة لتسجيل الدخول',
        },
        employee: {
            home: {
                searchPlaceholder: 'ابحث عن وظيفة...',
                recommendedJobs: 'وظائف مقترحة',
                allJobs: 'جميع الوظائف',
                viewAll: 'عرض الكل',
                noJobs: 'لا توجد وظائف متاحة',
                salaryNotSpecified: 'غير محدد',
                perMonth: '/ شهر',
                newJobs: 'وظائف جديدة',
                newJobsDescription: 'اكتشف الفرص الجديدة المتاحة لك الآن وابدأ رحلتك المهنية',
                recommendedForYou: 'وظائف مخصصه لك',
                allJobsTitle: 'كل الوظائف',
                more: 'المزيد',
                apply: 'تقديم',
                applied: 'تم التقديم',
                closed: 'مغلق',
                company: 'الشركة',
                jobTitle: 'المسمي الوظيفي',
                companyName: 'اسم الشركة',
                presenceType : {
                    remote: 'عن بعد',
                    hybrid: 'مختلط',
                    onsite: 'على موقع'
                },
                workType: {
                    fullTime: 'دوام كامل',
                    partTime: 'دوام جزئي',
                    contract: 'عقد',
                    freelance: 'عمل حر'
                },
                currency: {
                    USD: '$',
                    EUR: '€',
                    EGP: 'ج.م',
                    SAR: 'ر.س',
                },
                courses: 'الدورات التدريبية',
                videos: 'فيديو',
                startCourse: 'بدء الدورة',
                noCourses: 'لا توجد دورات متاحة',
                courseStarted: 'تم بدء الدورة بنجاح!',
                courseStartFailed: 'فشل بدء الدورة',
            },
            courseDetail: {
                loadFailed: 'فشل تحميل تفاصيل الدورة',
                courseNotFound: 'الدورة غير موجودة',
                progress: 'التقدم',
                completed: 'مكتمل',
                inProgress: 'قيد التنفيذ',
                videosTab: 'الفيديوهات',
                descriptionTab: 'الوصف',
                aboutCourse: 'عن الدورة',
                noDescription: 'لا يوجد وصف متاح',
                noVideos: 'لا توجد فيديوهات متاحة',
                watch: 'شاهد',
                courseCompleted: 'تم إكمال الدورة!',
                continueCourse: 'متابعة الدورة',
                videoCompleted: 'تم إكمال الفيديو!',
                locked: 'مقفل',
            },
            videoLesson: {
                loadFailed: 'فشل تحميل الفيديو',
                videoNotFound: 'الفيديو غير موجود',
                noVideoUrl: 'رابط الفيديو غير متاح',
                videoCompleted: 'تم إكمال الفيديو بنجاح!',
                completeFailed: 'فشل إكمال الفيديو',
                alreadyCompleted: 'تم إكمال الفيديو',
                completing: 'جاري الإكمال...',
                markAsCompleted: 'تمييز كمكتمل',
                backToCourse: 'العودة إلى الدورة',
                courseCompleted: 'تم إكمال الدورة!',
                courseCompletedMessage: 'تهانينا! لقد أكملت هذه الدورة بنجاح.',
                viewCourse: 'عرض الدورة',
                backToHome: 'العودة إلى الرئيسية',
            },
            coursesList: {
                title: 'الدورات التدريبية',
                subtitle: 'تصفح وابدأ التعلم من دوراتنا',
                searchPlaceholder: 'ابحث عن دورة...',
                allCourses: 'جميع الدورات',
                myCourses: 'دوراتي',
                noCourses: 'لا توجد دورات متاحة',
                noMyCourses: 'لم تبدأ أي دورة بعد',
                noResults: 'لا توجد دورات تطابق بحثك',
                browseCourses: 'تصفح الدورات',
                complete: 'مكتمل',
            },
            vacancyList: {
                title: 'الوظائف المتاحة',
                subtitle: 'ابحث عن وظيفة أحلامك',
                loadFailed: 'فشل تحميل الوظائف',
                saveSuccess: 'تم حفظ الوظيفة بنجاح',
                saveFailed: 'فشل حفظ الوظيفة',
                unsaveSuccess: 'تم إلغاء الحفظ',
                unsaveFailed: 'فشل إلغاء الحفظ',
                noResults: 'لا توجد وظائف تطابق الفلاتر',
                allWorkTypes: 'جميع أنواع العمل',
                allPresenceTypes: 'جميع أنواع الحضور',
                allStatuses: 'جميع الحالات',
                open: 'مفتوح',
                closed: 'مغلق',
                filters: 'الفلاتر',
                active: 'نشط',
                clear: 'مسح',
                workType: 'نوع العمل',
                presenceType: 'نوع الحضور',
                status: 'الحالة',
                searchPlaceholder: 'البحث باسم الوظيفة',
                apply: 'تطبيق الفلاتر',
                salaryRange: 'نطاق الراتب',
                minSalary: 'الحد الأدنى',
                maxSalary: 'الحد الأقصى',
                to: 'إلى',
                less: 'اقل',
                more: 'اعلي',
            },
            savedVacancies: {
                appliedJobs: 'وظائف مقدم عليها',
                savedJobs: 'وظائف محفوظة',
                noJobs: 'لا توجد وظائف متاحة',
                unsaveSuccess: 'تم إلغاء الحفظ',
                unsaveFailed: 'فشل إلغاء الحفظ',
                loadFailed: 'فشل تحميل البيانات',
                apply: 'تقديم',
                applied: 'تم التقديم',
            },
            notifications: {
                title: 'الإشعارات',
                loadFailed: 'فشل تحميل الإشعارات',
                noNotifications: 'لا توجد إشعارات',
                markAllAsRead: 'تحديد الكل كمقروء',
                allMarkedAsRead: 'تم تحديد جميع الإشعارات كمقروءة',
                loadMore: 'تحميل المزيد',
            },
            applications: {
                title: 'طلباتي',
                loadFailed: 'فشل تحميل الطلبات',
                noApplications: 'لا توجد طلبات متاحة',
                browseJobs: 'تصفح الوظائف',
                viewVacancy: 'عرض الوظيفة',
                withdrawApplication: 'سحب الطلب',
                withdrawConfirmTitle: 'هل أنت متأكد؟',
                withdrawConfirmText: 'هل أنت متأكد من سحب طلبك؟ لن تتمكن من التراجع عن هذا الإجراء.',
                withdrawConfirmButton: 'نعم، سحب الطلب',
                withdrawCancelButton: 'إلغاء',
                withdrawSuccessTitle: 'تم بنجاح!',
                withdrawSuccessText: 'تم سحب طلبك بنجاح',
                withdrawFailedTitle: 'خطأ!',
                withdrawFailedText: 'فشل سحب الطلب',
                ok: 'حسناً',
                appliedAt: 'تم التقديم:',
                status: {
                    all: 'الكل',
                    pending: 'قيد الانتظار',
                    viewed: 'تم المشاهدة',
                    accepted: 'مقبول',
                    rejected: 'مرفوض',
                },
                timeAgo: {
                    today: 'اليوم',
                    yesterday: 'منذ يوم',
                    daysAgo: 'منذ {days} أيام',
                    weeksAgo: 'منذ {weeks} أسابيع',
                    monthsAgo: 'منذ {months} أشهر',
                    yearsAgo: 'منذ {years} سنوات',
                },
            },
            vacancyDetail: {
                loadFailed: 'فشل تحميل تفاصيل الوظيفة',
                vacancyNotFound: 'الوظيفة غير موجودة',
                jobTitlePlaceholder: 'اسم الوظيفه هنا',
                companyNamePlaceholder: 'اسم الشركة هنا',
                egypt: 'مصر',
                viewOnMap: 'عرض على الخريطة',
                descriptionTab: 'وصف الوظيفة',
                companyTab: 'الشركة',
                aboutCompany: 'عن الشركة',
                readMore: 'اقراء المزيد',
                readLess: 'اقرأ أقل',
                companyAddress: 'عنوان الشركة',
                companyPhone: 'رقم الهاتف',
                companyEmail: 'البريد الإلكتروني',
                companyWebsite: 'رابط الموقع الإلكتروني',
                companyEmployeesCount: 'عدد الموظفين',
                recruitmentCompany: 'شركة التوظيف',
                aboutRecruitmentCompany: 'عن شركة التوظيف',
                targetCompanyDescription: 'معلومات عن الشركة التي تقدم هذه الوظيفة',
                recruitmentCompanyDescription: 'معلومات عن شركة التوظيف التي نشرت هذه الوظيفة',
                jobInformation: 'معلومات عن الوظيفة',
                jobTitle: 'الوظيفة',
                company: 'الشركة',
                academicDegree: 'المؤهل',
                experience: 'الخبرات',
                years: 'سنوات',
                workType: 'طبيعة العمل',
                notSpecified: 'غير محدد',
                skills: 'المهارات المطلوبة',
                requirements: 'المتطلبات',
                benefits: 'المرافق وغيرها',
                apply: 'تقديم',
                applied: 'تم التقديم',
                saveSuccess: 'تم حفظ الوظيفة',
                saveFailed: 'فشل حفظ الوظيفة',
                unsaveSuccess: 'تم إلغاء الحفظ',
                unsaveFailed: 'فشل إلغاء الحفظ',
                defaultLocation: 'القاهرة',
                timeAgo: {
                    today: 'اليوم',
                    yesterday: 'منذ يوم',
                    daysAgo: 'منذ {days} أيام',
                    weeksAgo: 'منذ {weeks} أسابيع',
                    monthsAgo: 'منذ {months} أشهر',
                    yearsAgo: 'منذ {years} سنوات',
                },
            },
            profile: {
                jobTitle: 'المسمى الوظيفي',
                jobTitleNotSet: 'لم يتم تحديد المسمى الوظيفي',
                aboutMe: 'نبذة عني',
                aboutMeNotSet: 'لم يتم إضافة نبذة عنك',
                skills: 'المهارات',
                noSkills: 'لم يتم إضافة مهارات',
                workExperience: 'خبرة العمل',
                noWorkExperience: 'لم يتم إضافة خبرة عمل',
                education: 'التعليم',
                noEducation: 'لم يتم إضافة تعليم',
                cv: 'السيرة الذاتية',
                noCv: 'لم يتم رفع السيرة الذاتية',
                uploadCv: 'رفع السيرة الذاتية',
                updateCv: 'تحديث السيرة الذاتية',
                downloadCv: 'تنزيل السيرة الذاتية',
                viewCv: 'عرض السيرة الذاتية',
                contactInformation: 'معلومات الاتصال',
                edit: 'تعديل',
                add: 'إضافة',
                delete: 'حذف',
                save: 'حفظ',
                cancel: 'إلغاء',
                updateSuccess: 'تم التحديث بنجاح',
                updateFailed: 'فشل التحديث',
                deleteSuccess: 'تم الحذف بنجاح',
                deleteFailed: 'فشل الحذف',
                uploadSuccess: 'تم الرفع بنجاح',
                uploadFailed: 'فشل الرفع',
                loadingFailed: 'فشل تحميل البيانات',
                imageUploadFailed: 'فشل رفع الصورة',
                imageSizeError: 'حجم الصورة يجب ألا يتجاوز 5 ميجابايت',
                imageFormatError: 'يجب أن تكون الصورة بصيغة PNG أو JPG أو WEBP',
                uploadingImage: 'جاري رفع الصورة...',
                imageUploadSuccess: 'تم تحديث الصورة بنجاح',
                jobTitleUpdateSuccess: 'تم تحديث المسمى الوظيفي بنجاح',
                jobTitleUpdateFailed: 'فشل تحديث المسمى الوظيفي',
                bioUpdateSuccess: 'تم تحديث النبذة بنجاح',
                bioUpdateFailed: 'فشل تحديث النبذة',
                selectJobTitle: 'اختر المسمى الوظيفي',
                jobTitleRequired: 'يرجى اختيار المسمى الوظيفي',
                enterBio: 'أدخل نبذة عنك',
                months:  ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
                yearsAgo: 'منذ {years} سنوات',
                editJobTitle: 'تعديل المسمى الوظيفي',
                editAbout: 'تعديل نبذة عني',
                personalBio: 'النبذة الشخصية',
                bioPlaceholder: 'اكتب نبذة مختصرة عنك وخبراتك ومهاراتك...',
                bioMaxLength: 'الحد الأقصى 2000 حرف',
                addWorkExperience: 'إضافة خبرة عمل',
                editWorkExperience: 'تعديل خبرة عمل',
                companyName: 'اسم الشركة',
                companyNamePlaceholder: 'أدخل اسم الشركة',
                fromDate: 'من تاريخ',
                toDate: 'إلى تاريخ',
                toDateHint: 'اتركه فارغاً للوظيفة الحالية',
                description: 'الوصف',
                descriptionPlaceholder: 'اكتب وصفاً مختصراً عن مسؤولياتك وإنجازاتك (اختياري)',
                fillAllRequired: 'يرجى ملء جميع الحقول المطلوبة',
                endDateAfterStart: 'تاريخ النهاية يجب أن يكون بعد تاريخ البداية',
                workExperienceAdded: 'تم إضافة خبرة العمل بنجاح',
                workExperienceAddFailed: 'فشل إضافة خبرة العمل',
                workExperienceUpdated: 'تم تحديث خبرة العمل بنجاح',
                workExperienceUpdateFailed: 'فشل تحديث خبرة العمل',
                workExperienceNotFound: 'خبرة العمل غير موجودة',
                workExperienceDeleted: 'تم حذف خبرة العمل بنجاح',
                workExperienceDeleteFailed: 'فشل حذف خبرة العمل',
                saveChanges: 'حفظ التغييرات',
                from: 'من',
                until: 'حتى',
                untilNow: 'حتى الآن',
                addEducation: 'إضافة تعليم',
                editEducation: 'تعديل تعليم',
                educationHistory: 'الشهادات',
                academicDegree: 'الدرجة التعليمية',
                academicDegreePlaceholder: 'مثال: بكالوريوس، ماجستير، دكتوراه',
                educationAuthority: 'اسم الجامعة / المؤسسة التعليمية',
                educationAuthorityPlaceholder: 'أدخل اسم الجامعة أو المؤسسة التعليمية',
                specialization: 'التخصص',
                specializationPlaceholder: 'مثال: علوم الحاسب، إدارة الأعمال',
                grade: 'التقدير / المعدل',
                gradePlaceholder: 'مثال: ممتاز، جيد جداً، 3.5/4',
                graduationDate: 'تاريخ التخرج',
                educationAdded: 'تم إضافة الشهادة بنجاح',
                educationAddFailed: 'فشل إضافة الشهادة',
                educationUpdated: 'تم تحديث الشهادة بنجاح',
                educationUpdateFailed: 'فشل تحديث الشهادة',
                educationNotFound: 'الشهادة غير موجودة',
                educationDeleted: 'تم حذف الشهادة بنجاح',
                educationDeleteFailed: 'فشل حذف الشهادة',
                noEducationRecorded: 'لا يوجد شهادات مسجلة',
                replaceCv: 'استبدال السيرة الذاتية',
                uploadCvButton: 'رفع سيرة ذاتية',
                noCvText: 'لا توجد سيرة ذاتية',
                deleteConfirmTitle: 'هل أنت متأكد؟',
                deleteConfirmText: 'هل أنت متأكد من حذف هذا العنصر؟',
                deleteConfirmButton: 'نعم، احذف',
                deleteCancelButton: 'إلغاء',
                deleteSuccessTitle: 'تم بنجاح!',
                deleteSuccessText: 'تم الحذف بنجاح',
                deleteFailedTitle: 'خطأ!',
                deleteFailedText: 'فشل الحذف',
            },
            editProfile: {
                title: 'تعديل الملف الشخصي',
                phone: 'رقم الهاتف',
                phonePlaceholder: 'أدخل رقم الهاتف',
                phoneRequired: 'رقم الهاتف مطلوب',
                email: 'البريد الإلكتروني',
                emailPlaceholder: 'أدخل البريد الإلكتروني',
                emailRequired: 'البريد الإلكتروني مطلوب',
                emailInvalid: 'البريد الإلكتروني غير صحيح',
                save: 'حفظ',
                saving: 'جاري الحفظ...',
                updateSuccess: 'تم تحديث الملف الشخصي بنجاح',
                updateFailed: 'فشل تحديث الملف الشخصي',
                loadFailed: 'فشل تحميل البيانات',
                uploadingImage: 'جاري رفع الصورة...',
                imageUploadSuccess: 'تم تحديث الصورة بنجاح',
                imageUploadFailed: 'فشل رفع الصورة',
            },
            settings: {
                title: 'الإعدادات',
                editAccount: 'تعديل حسابي',
                changePassword: 'تغيير كلمة المرور',
                aboutApp: 'عن التطبيق',
                termsOfUse: 'شروط الاستخدام',
                contactUs: 'تواصل معانا',
                deleteAccount: 'حذف حساب',
                logout: 'تسجيل خروج',
                changePasswordTitle: 'تغيير كلمة المرور',
                currentPassword: 'كلمة المرور الحالية',
                currentPasswordPlaceholder: 'أدخل كلمة المرور الحالية',
                currentPasswordRequired: 'يرجى إدخال كلمة المرور الحالية',
                newPassword: 'كلمة المرور الجديدة',
                newPasswordPlaceholder: 'أدخل كلمة المرور الجديدة',
                newPasswordRequired: 'يرجى إدخال كلمة المرور الجديدة',
                newPasswordMinLength: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
                confirmPassword: 'تأكيد كلمة المرور',
                confirmPasswordPlaceholder: 'أعد إدخال كلمة المرور الجديدة',
                confirmPasswordMismatch: 'كلمة المرور الجديدة وتأكيدها غير متطابقين',
                passwordHint: 'يجب أن تكون 8 أحرف على الأقل',
                save: 'حفظ',
                cancel: 'إلغاء',
                passwordChangeSuccess: 'تم تغيير كلمة المرور بنجاح',
                passwordChangeFailed: 'فشل تغيير كلمة المرور',
                aboutAppTitle: 'عن التطبيق',
                aboutAppDescription: 'تطبيق توظيف هو منصة متكاملة لربط الباحثين عن عمل مع الشركات والجهات التوظيفية.',
                appVersion: 'نسخة التطبيق: 1.0.0',
                allRightsReserved: 'جميع الحقوق محفوظة © 2024',
                ok: 'حسناً',
                termsTitle: 'شروط الاستخدام',
                termsContent: {
                    acceptance: '1. القبول: باستخدامك لهذا التطبيق، فإنك توافق على الالتزام بشروط الاستخدام هذه.',
                    allowedUse: '2. الاستخدام المسموح: يجب استخدام التطبيق للأغراض القانونية فقط ووفقاً للقوانين المعمول بها.',
                    privacy: '3. الخصوصية: نحن نلتزم بحماية خصوصية بياناتك وفقاً لسياسة الخصوصية الخاصة بنا.',
                    liability: '4. المسؤولية: نحن لا نتحمل أي مسؤولية عن أي أضرار قد تنتج عن استخدام التطبيق.',
                    modifications: '5. التعديلات: نحتفظ بالحق في تعديل هذه الشروط في أي وقت دون إشعار مسبق.',
                },
                contactTitle: 'تواصل معنا',
                email: 'البريد الإلكتروني:',
                phone: 'الهاتف:',
                address: 'العنوان:',
                addressValue: 'المملكة العربية السعودية',
                deleteAccountTitle: 'هل أنت متأكد من حذف حسابك؟',
                deleteAccountWarning: 'لن تتمكن من التراجع عن هذا الإجراء. سيتم حذف جميع بياناتك بشكل دائم.',
                deleteAccountButton: 'حذف الحساب',
                deleteAccountInfo: 'ميزة حذف الحساب قريباً',
                deleteAccountFailed: 'فشل حذف الحساب',
                logoutTitle: 'هل أنت متأكد من تسجيل الخروج؟',
                logoutButton: 'تسجيل الخروج',
                logoutSuccess: 'تم تسجيل الخروج بنجاح',
                changeLanguage: 'تغيير اللغة',
                languageChanged: 'تم تغيير اللغة بنجاح',
                currentLanguage: 'اللغة الحالية',
                selectLanguage: 'اختر اللغة',
            },
            navigation: {
                home : 'الرئيسية',
                saved : 'محفوظات',
                applications : 'التقديمات',
                profile : 'الملف الشخصي',
            }
        },
        company: {
            settings: {
                editCompanyProfile:'تعديل معلومات الشركة',
                title:'الإعدادات',
                editAccount:'تعديل حسابي',
                manageUsers:'إدارة المستخدمين',
                changePassword:'تغيير كلمة المرور',
                editMyAccount:'تعديل حسابي',
                logout:'تسجيل خروج',
                changePasswordTitle:'تغيير كلمة المرور',
                currentPassword:'كلمة المرور الحالية',
                currentPasswordPlaceholder:'أدخل كلمة المرور الحالية',
                currentPasswordRequired:'يرجى إدخال كلمة المرور الحالية',
                newPassword:'كلمة المرور الجديدة',
                newPasswordPlaceholder:'أدخل كلمة المرور الجديدة',
                newPasswordRequired:'يرجى إدخال كلمة المرور الجديدة',
                newPasswordMinLength:'يرجى إدخال كلمة المرور الجديدة بأقل من 8 أحرف',
                confirmPassword:'تأكيد كلمة المرور',
                confirmPasswordPlaceholder:'أعد إدخال كلمة المرور الجديدة',
                confirmPasswordMismatch:'كلمة المرور الجديدة وتأكيدها غير متطابقين',
                passwordHint:'يرجى إدخال كلمة المرور الجديدة بأقل من 8 أحرف',
                save:'حفظ',
                cancel:'إلغاء',
                passwordChangeSuccess:'تم تغيير كلمة المرور بنجاح',
                passwordChangeFailed:'فشل تغيير كلمة المرور',
                logoutTitle:'هل أنت متأكد من تسجيل الخروج؟',
                logoutButton:'تسجيل الخروج',
                logoutSuccess:'تم تسجيل الخروج بنجاح',
                changeLanguage:'تغيير اللغة',
                languageChanged:'تم تغيير اللغة بنجاح',
                currentLanguage:'اللغة الحالية',
                selectLanguage:'اختر اللغة',
                arabic:'العربية',
                deleteAccount:'حذف الحساب',
                deleteAccountTitle:'هل أنت متأكد من حذف حسابك؟',
                deleteAccountWarning:'لن تتمكن من التراجع عن هذا الإجراء. سيتم حذف جميع بياناتك بشكل دائم.',
                deleteAccountButton:'حذف الحساب',
                deleteAccountInfo:'ميزة حذف الحساب قريباً',
                deleteAccountFailed:'فشل حذف الحساب',
                english:'الانجليزية',
            },
            createVacancy: {
                title: 'إنشاء وظيفة جديدة',
                subtitle: 'إنشاء وظيفة جديدة بالمعلومات الأساسية',
                basicInfo: 'المعلومات الأساسية',
                jobTitle: 'المسمى الوظيفي',
                jobTitleRequired: 'يرجى إدخال المسمى الوظيفي',
                selectJobTitle: 'اختر المسمى الوظيفي',
                workType: 'نوع العمل',
                selectType: 'اختر النوع',
                presenceType: 'نوع الوجود',
                experience: 'الخبرة',
                academicDegree: 'الدرجة التعليمية',
                academicDegreePlaceholder: 'مثال: بكالوريوس، ماجستير، دكتوراه',
                salaryLocation: 'الراتب والموقع',
                salary: 'الراتب',
                currency: 'العملة',
                currencyPlaceholder: 'مثال: دولار، ريال، يورو',
                latitude: 'خط عرض الموقع',
                longitude: 'خط طول الموقع',
                details: 'التفاصيل',
                description: 'الوصف',
                descriptionPlaceholder: 'اكتب وصفاً مختصراً عن مسؤولياتك وإنجازاتك (اختياري)',
                privileges: 'المزايا',
                privilegesPlaceholder: 'اكتب مزايا وفوائد الوظيفة (اختياري)',
                status: 'الحالة',
                open: 'مفتوح',
                closed: 'مغلق',
                cancel: 'إلغاء',
                create: 'إنشاء',
                creating: 'جاري الإنشاء...',
                createSuccess: 'تم إنشاء الوظيفة بنجاح',
                createFailed: 'فشل إنشاء الوظيفة',
                USD: 'USD',
                EGP : 'EGP',
                EUR : 'EUR',
                skills: 'المهارات',
                skillsDescription: 'اختر المهارات المطلوبة لهذه الوظيفة',
                noSkillsAvailable: 'لا توجد مهارات متاحة',
            },
            vacancyManagement: {
                title: 'إدارة الوظائف',
                subtitle: 'إدارة كافة الوظائف المنشورة',
                createNew: 'إنشاء وظيفة جديدة',
                noVacancies: 'لم تنشئ أي وظيفة بعد',
                loadFailed: 'فشل تحميل الوظائف',
                deleteConfirm: 'هل أنت متأكد من حذف هذه الوظيفة؟',
                deleteWarning: 'لن تتمكن من التراجع عن هذا الإجراء.',
                delete: 'حذف',
                deleteSuccess: 'تم حذف الوظيفة بنجاح',
                deleteFailed: 'فشل حذف الوظيفة',
                open: 'مفتوح',
                closed: 'مغلق',
                notSpecified: 'غير محدد',
                viewDetails: 'عرض التفاصيل',
                viewApplications: 'عرض التطبيقات',
            },
            profile: {
                title: 'معلومات الشركة',
                loadFailed: 'فشل تحميل معلومات الشركة',
                name: 'اسم الشركة',
                bio: 'وصف',
                noBio: 'لم يتم إضافة وصف للشركة بعد.',
                address: 'العنوان',
                website: 'الموقع الإلكتروني',
                email: 'البريد الإلكتروني',
                phone: 'رقم الهاتف',
                employeesCount: 'عدد الموظفين',
                image: 'صورة الشركة',
                pdf: 'ملف PDF للشركة',
                viewPdf: 'عرض PDF',
                view: 'عرض',
                edit: 'تعديل',
                clickToView: 'انقر للعرض',
                noPdf: 'لم يتم إضافة ملف PDF للشركة بعد.',

            },
            editProfile: {
                title: 'تعديل معلومات الشركة',
                subtitle: 'تعديل معلومات الشركة',
                name: 'اسم الشركة',
                nameRequired: 'يرجى إدخال اسم الشركة',
                bio: 'وصف',
                bioPlaceholder: 'اكتب وصف الشركة',
                address: 'العنوان',
                website: 'الموقع الإلكتروني',
                email: 'البريد الإلكتروني',
                emailRequired: 'يرجى إدخال البريد الإلكتروني',
                emailInvalid: 'البريد الإلكتروني غير صحيح',
                phone: 'رقم الهاتف',
                employeesCount: 'عدد الموظفين',
                image: 'صورة الشركة',
                pdf: 'ملف PDF للشركة',
                pdfHint: 'ملفات PDF فقط (الحد الأقصى 10 ميجابايت)',
                pdfInvalid: 'يرجى رفع ملف PDF',
                pdfSizeError: 'يجب ألا يتجاوز حجم ملف PDF 10 ميجابايت',
                pdfSelected: 'تم الاختيار',
                viewCurrentPdf: 'عرض PDF الحالي',
                currentPdf: 'PDF الحالي',
                clickToView: 'انقر للعرض',
                view: 'عرض',
                uploadPdf: 'رفع ملف PDF',
                dragDropPdf: 'اسحب وأفلت ملف PDF هنا، أو انقر للتصفح',
                remove: 'إزالة',
                save: 'حفظ',
                saving: 'جاري الحفظ...',
                saveSuccess: 'تم تحديث معلومات الشركة بنجاح بنجاح',
                saveFailed: 'فشل تحديث معلومات الشركة',
                uploadImage: 'رفع صورة الشركة',
                changeImage: 'تغيير صورة الشركة',
            },
            notifications: {
                title: 'الإشعارات',
                loadFailed: 'فشل تحميل الإشعارات',
                noNotifications: 'لا توجد إشعارات',
                markAllAsRead: 'تحديد الكل كمقروء',
                allMarkedAsRead: 'تم تحديد جميع الإشعارات كمقروءة',
                loadMore: 'تحميل المزيد',
            },
            vacancyDetail: {
                title: 'تفاصيل الوظيفة',
                edit: 'تعديل',
                delete: 'حذف',
                applications: 'التطبيقات',
                status: 'الحالة',
                open: 'مفتوح',
                closed: 'مغلق',
                notFound: 'الوظيفة غير موجودة',
                backToList: 'العودة إلى قائمة الوظائف',
                loadFailed: 'فشل تحميل تفاصيل الوظيفة',
                description: 'الوصف',
                details: 'التفاصيل',
                skills: 'المهارات المطلوبة',
                jobInformation: 'معلومات عن الوظيفة',
                jobTitle: 'الوظيفة',
                academicDegree: 'المؤهل',
                experience: 'الخبرات',
                workType: 'طبيعة العمل',
                presenceType: 'نوع الحضور',
                salary: 'الراتب',
                company: 'الشركة',
                applicationsTab: 'الطلبات',
                descriptionTab: 'وصف الوظيفة',
                noApplications: 'لا توجد طلبات حتى الآن',
                applicationsCount: 'يوجد {count} طلب على هذه الوظيفة',
                viewAllApplications: 'عرض جميع الطلبات',
            },
            editVacancy: {
                title: 'تعديل الوظيفة',
                subtitle: 'تعديل تفاصيل الوظيفة',
                update: 'تحديث',
                updating: 'جاري التحديث...',
                updateSuccess: 'تم تحديث تفاصيل الوظيفة بنجاح',
                updateFailed: 'فشل تحديث تفاصيل الوظيفة',
            },
            vacancyApplications: {
                title: 'طلبات التطبيق',
                noApplications: 'لا يوجد طلبات تطبيق',
                loadFailed: 'فشل تحميل الطلبات',
                applicant: 'المتقدم',
                appliedDate: 'تاريخ التطبيق',
                status: 'الحالة',
                actions: 'الإجراءات',
                view: 'عرض',
                accept: 'قبول',
                reject: 'رفض',
                pending: 'قيد الانتظار',
                accepted: 'مقبول',
                rejected: 'مرفوض',
                viewProfile: 'عرض الملف الشخصي',
            },
            users: {
                title: 'مستخدمي الشركة',
                createNew: 'إضافة مستخدم جديد',
                noUsers: 'لا يوجد مستخدمين للشركة',
                loadFailed: 'فشل تحميل مستخدمي الشركة',
                name: 'الاسم',
                email: 'البريد الإلكتروني',
                role: 'الدور',
                actions: 'الإجراءات',
                edit: 'تعديل',
                delete: 'حذف',
            },
            userCreate: {
                title: 'إضافة مستخدم جديد',
                name: 'الاسم',
                nameRequired: 'يرجى إدخال الاسم',
                email: 'البريد الإلكتروني',
                emailRequired: 'يرجى إدخال البريد الإلكتروني',
                emailInvalid: 'البريد الإلكتروني غير صحيح',
                password: 'كلمة المرور',
                passwordRequired: 'يرجى إدخال كلمة المرور',
                passwordMinLength: 'يرجى إدخال كلمة المرور بأقل من 8 أحرف',
                role: 'الدور',
                roleRequired: 'يرجى إدخال الدور',
                create: 'إنشاء',
                creating: 'جاري الإنشاء...',
                createSuccess: 'تم إنشاء المستخدم بنجاح',
                createFailed: 'فشل إنشاء المستخدم',
            },
            userEdit: {
                title: 'تعديل مستخدم',
                update: 'تحديث',
                updating: 'جاري التحديث...',
                updateSuccess: 'تم تحديث المستخدم بنجاح',
                updateFailed: 'فشل تحديث المستخدم',
            },
            plans: {
                title: 'الخطط',
                subtitle: 'باقات الاشتراك',
                subtitleDescription: 'اختر الباقة المناسبة لشركتك',
                loadFailed: 'فشل تحميل الخطط',
                subscribe: 'اشترك',
                subscribeNow: 'اشترك الآن',
                subscribing: 'جارٍ الاشتراك...',
                subscribeSuccess: 'تم الاشتراك بنجاح',
                subscribeFailed: 'فشل الاشتراك',
                currentPlan: 'الخطة الحالية',
                noPlansAvailable: 'لا توجد باقات متاحة حالياً',
                planName: 'الباقة',
                duration: 'المدة',
                durationDays: 'يوم',
                vacanciesLimit: 'عدد الوظائف',
                clientsLimit: 'العملاء',
                unlimited: 'غير محدود',
            },
            subscriptions: {
                title: 'الاشتراكات',
                noSubscriptions: 'لا يوجد اشتراكات',
                loadFailed: 'فشل تحميل الاشتراكات',
                cancelSuccess : 'تم إلغاء الاشتراك بنجاح',
                cancelFailed : 'فشل إلغاء الاشتراك',
                title : 'الاشتراكات',
                subtitle : 'الاشتراكات',
                allSubscriptions : 'جميع الاشتراكات',
                active : 'مفعل',
                canceled : 'ملغي',
                expired : 'منتهي',
                noSubscriptions : 'لا يوجد اشتراكات',
                plan : 'الخطة',
                price : 'السعر',
                status : 'الحالة',
                startDate : 'تاريخ البدء',
                endDate : 'تاريخ الانتهاء',
                actions : 'الإجراءات',
                subscription : 'الاشتراك',
                cancelling : 'جاري الإلغاء',
                cancelSubscription : 'إلغاء الاشتراك',
            },
            subscriptionDetail: {
                title: 'تفاصيل الاشتراك',
                loadFailed: 'فشل تحميل تفاصيل الاشتراك',
            },
            navigation: {
                vacancies: 'الوظائف',
                subscriptions: 'الاشتراكات',
                addVacancy: 'إضافة وظيفة',
                plans: 'الخطط',
                profile: 'المعلومات',
            },
            nav: {
                company: 'الشركة',
                recruitmentCompany: 'شركة التوظيف',
            },
        },
    },
    en: {
        login: {
            title: 'Welcome back!',
            email: 'Email',
            emailPlaceholder: 'example@email.com',
            emailRequired: 'Email is required',
            emailInvalid: 'Invalid email format',
            password: 'Password',
            passwordPlaceholder: '••••••••••••',
            passwordRequired: 'Password is required',
            passwordMinLength: 'Password must be at least 8 characters',
            rememberMe: 'Remember me',
            forgotPassword: 'Forgot password',
            loginButton: 'Login',
            loginButtonLoading: 'Logging in...',
            noAccount: "Don't have an account?",
            createAccount: 'Create account now',
            loginSuccess: 'Login successful!',
            loginError: 'Login failed',
            language: 'Language',
            switchToEnglish: 'English',
            switchToArabic: 'العربية',
        },
        register: {
            title: 'Create New Account',
            name: 'Name',
            namePlaceholder: 'Enter your full name',
            nameRequired: 'Name is required',
            email: 'Email',
            emailPlaceholder: 'example@email.com',
            emailRequired: 'Email is required',
            emailInvalid: 'Invalid email format',
            phone: 'Phone Number',
            phoneRequired: 'Phone number is required',
            password: 'Password',
            passwordPlaceholder: '••••••••••••',
            passwordRequired: 'Password is required',
            passwordMinLength: 'Password must be at least 8 characters',
            confirmPassword: 'Confirm Password',
            confirmPasswordPlaceholder: '••••••••••••',
            confirmPasswordRequired: 'Please confirm your password',
            confirmPasswordMismatch: 'Passwords do not match',
            role: 'Role',
            roleRequired: 'Role is required',
            roleEmployee: 'Job Seeker',
            roleCompany: 'Company',
            roleRecruitmentCompany: 'Recruitment Company',
            registerButton: 'Create Account',
            registerButtonLoading: 'Creating account...',
            hasAccount: 'Already have an account?',
            loginLink: 'Login',
            registerSuccess: 'Account created successfully!',
            registerSuccessVerify: 'Account created successfully! Please verify your email.',
            registerError: 'Failed to create account',
        },
        verifyEmail: {
            verifyEmailTitle: 'Verify Email',
            verificationCodeSentToEmail: 'Verification code has been sent to your email:',
            email: 'Email',
            emailPlaceholder: 'example@email.com',
            emailRequired: 'Email is required',
            emailInvalid: 'Invalid email format',
            verificationCode: 'Verification Code',
            enterVerificationCode: 'Please enter the verification code',
            emailNotFound: 'Email not found',
            emailVerifiedSuccessfully: 'Email verified successfully!',
            emailVerificationFailed: 'Email verification failed',
            resendVerificationCode: 'Resend Verification Code',
            resendingVerificationCode: 'Resending...',
            resendVerificationCodeSuccessfully: 'Verification code resent successfully',
            resendVerificationCodeFailed: 'Failed to resend verification code',
            verifyingCode: 'Verifying...',
            verify: 'Verify',
            didNotReceiveCode: "Didn't receive the code?",
            returnToLogin: 'Return to Login',
        },
        employee: {
            home: {
                searchPlaceholder: 'Search for a job...',
                recommendedJobs: 'Recommended Jobs',
                allJobs: 'All Jobs',
                viewAll: 'View All',
                noJobs: 'No jobs available',
                salaryNotSpecified: 'Not specified',
                perMonth: '/ month',
                newJobs: 'New Jobs',
                newJobsDescription: 'Discover new opportunities available to you now and start your professional journey',
                recommendedForYou: 'Recommended for You',
                allJobsTitle: 'All Jobs',
                more: 'More',
                apply: 'Apply',
                applied: 'Applied',
                closed: 'Closed',
                company: 'Company',
                jobTitle: 'Job Title',
                companyName: 'Company Name',
                presenceType: {
                    remote: 'Remote',
                    hybrid: 'Hybrid',
                    onsite: 'Onsite'
                },
                currency: {
                    USD: 'USD',
                    EUR: 'EUR',
                    EGP: 'EGP',
                    SAR: 'SAR',
                },
                workType: {
                    fullTime: 'Full Time',
                    partTime: 'Part Time',
                    contract: 'Contract',
                    freelance: 'Freelance'
                },
                courses: 'Courses',
                videos: 'videos',
                startCourse: 'Start Course',
                noCourses: 'No courses available',
                courseStarted: 'Course started successfully!',
                courseStartFailed: 'Failed to start course',
            },
            courseDetail: {
                loadFailed: 'Failed to load course details',
                courseNotFound: 'Course not found',
                progress: 'Progress',
                completed: 'Completed',
                inProgress: 'In Progress',
                videosTab: 'Videos',
                descriptionTab: 'Description',
                aboutCourse: 'About Course',
                noDescription: 'No description available',
                noVideos: 'No videos available',
                watch: 'Watch',
                courseCompleted: 'Course Completed!',
                continueCourse: 'Continue Course',
                videoCompleted: 'Video completed!',
                locked: 'Locked',
            },
            videoLesson: {
                loadFailed: 'Failed to load video',
                videoNotFound: 'Video not found',
                noVideoUrl: 'Video URL not available',
                videoCompleted: 'Video completed successfully!',
                completeFailed: 'Failed to complete video',
                alreadyCompleted: 'Video Completed',
                completing: 'Completing...',
                markAsCompleted: 'Mark as Completed',
                backToCourse: 'Back to Course',
                courseCompleted: 'Course Completed!',
                courseCompletedMessage: 'Congratulations! You have successfully completed this course.',
                viewCourse: 'View Course',
                backToHome: 'Back to Home',
            },
            coursesList: {
                title: 'Courses',
                subtitle: 'Browse and start learning from our courses',
                searchPlaceholder: 'Search courses...',
                allCourses: 'All Courses',
                myCourses: 'My Courses',
                noCourses: 'No courses available',
                noMyCourses: 'You haven\'t started any courses yet',
                noResults: 'No courses found matching your search',
                browseCourses: 'Browse Courses',
                complete: 'complete',
            },
            vacancyList: {
                title: 'Job Vacancies',
                subtitle: 'Find your dream job',
                loadFailed: 'Failed to load vacancies',
                saveSuccess: 'Vacancy saved successfully',
                saveFailed: 'Failed to save vacancy',
                unsaveSuccess: 'Vacancy unsaved',
                unsaveFailed: 'Failed to unsave vacancy',
                noResults: 'No vacancies found matching your filters',
                allWorkTypes: 'All Work Types',
                allPresenceTypes: 'All Presence Types',
                allStatuses: 'All Statuses',
                open: 'Open',
                closed: 'Closed',
                filters: 'Filters',
                active: 'active',
                clear: 'Clear',
                workType: 'Work Type',
                presenceType: 'Presence Type',
                status: 'Status',
                searchPlaceholder: 'Search by job title',
                apply: 'Apply Filters',
                salaryRange: 'Salary Range',
                minSalary: 'Min',
                maxSalary: 'Max',
                to: 'to',
                less: 'Less',
                more: 'More',
            },
            savedVacancies: {
                appliedJobs: 'Applied Jobs',
                savedJobs: 'Saved Jobs',
                noJobs: 'No jobs available',
                unsaveSuccess: 'Unsaved successfully',
                unsaveFailed: 'Failed to unsave',
                loadFailed: 'Failed to load data',
                apply: 'Apply',
                applied: 'Applied',
            },
            applications: {
                title: 'My Applications',
                loadFailed: 'Failed to load applications',
                noApplications: 'No applications available',
                browseJobs: 'Browse Jobs',
                viewVacancy: 'View Vacancy',
                withdrawApplication: 'Withdraw Application',
                withdrawConfirmTitle: 'Are you sure?',
                withdrawConfirmText: 'Are you sure you want to withdraw your application? You will not be able to undo this action.',
                withdrawConfirmButton: 'Yes, withdraw',
                withdrawCancelButton: 'Cancel',
                withdrawSuccessTitle: 'Success!',
                withdrawSuccessText: 'Your application has been withdrawn successfully',
                withdrawFailedTitle: 'Error!',
                withdrawFailedText: 'Failed to withdraw application',
                ok: 'OK',
                appliedAt: 'Applied:',
                status: {
                    all: 'All',
                    pending: 'Pending',
                    viewed: 'Viewed',
                    accepted: 'Accepted',
                    rejected: 'Rejected',
                },
                timeAgo: {
                    today: 'Today',
                    yesterday: 'Yesterday',
                    daysAgo: '{days} days ago',
                    weeksAgo: '{weeks} weeks ago',
                    monthsAgo: '{months} months ago',
                    yearsAgo: '{years} years ago',
                },
            },
            vacancyDetail: {
                loadFailed: 'Failed to load vacancy details',
                vacancyNotFound: 'Vacancy not found',
                jobTitlePlaceholder: 'Job title here',
                companyNamePlaceholder: 'Company name here',
                egypt: 'Egypt',
                viewOnMap: 'View on Map',
                descriptionTab: 'Job Description',
                companyTab: 'Company',
                aboutCompany: 'About Company',
                readMore: 'Read More',
                readLess: 'Read Less',
                companyAddress: 'Company Address',
                companyPhone: 'Phone Number',
                companyEmail: 'Email',
                companyWebsite: 'Website',
                companyEmployeesCount: 'Number of Employees',
                recruitmentCompany: 'Recruitment Company',
                aboutRecruitmentCompany: 'About the Recruitment Company',
                targetCompanyDescription: 'Information about the company offering this position',
                recruitmentCompanyDescription: 'Information about the recruitment company that posted this vacancy',
                jobInformation: 'Job Information',
                jobTitle: 'Job Title',
                academicDegree: 'Academic Degree',
                experience: 'Experience',
                years: 'years',
                workType: 'Work Type',
                notSpecified: 'Not specified',
                skills: 'Required Skills',
                requirements: 'Requirements',
                benefits: 'Benefits and Facilities',
                apply: 'Apply',
                applied: 'Applied',
                saveSuccess: 'Vacancy saved successfully',
                saveFailed: 'Failed to save vacancy',
                unsaveSuccess: 'Unsaved successfully',
                unsaveFailed: 'Failed to unsave',
                defaultLocation: 'Cairo',
                timeAgo: {
                    today: 'Today',
                    yesterday: 'Yesterday',
                    daysAgo: '{days} days ago',
                    weeksAgo: '{weeks} weeks ago',
                    monthsAgo: '{months} months ago',
                    yearsAgo: '{years} years ago',
                },
            },
            profile: {
                jobTitle: 'Job Title',
                jobTitleNotSet: 'Job title not set',
                aboutMe: 'About Me',
                aboutMeNotSet: 'No bio added',
                skills: 'Skills',
                noSkills: 'No skills added',
                workExperience: 'Work Experience',
                noWorkExperience: 'No work experience added',
                education: 'Education',
                noEducation: 'No education added',
                cv: 'CV',
                noCv: 'No CV uploaded',
                uploadCv: 'Upload CV',
                updateCv: 'Update CV',
                downloadCv: 'Download CV',
                viewCv: 'View CV',
                contactInformation: 'Contact Information',
                edit: 'Edit',
                add: 'Add',
                delete: 'Delete',
                save: 'Save',
                cancel: 'Cancel',
                updateSuccess: 'Updated successfully',
                updateFailed: 'Update failed',
                deleteSuccess: 'Deleted successfully',
                deleteFailed: 'Delete failed',
                uploadSuccess: 'Uploaded successfully',
                uploadFailed: 'Upload failed',
                loadingFailed: 'Failed to load data',
                imageUploadFailed: 'Failed to upload image',
                imageSizeError: 'Image size must not exceed 5MB',
                imageFormatError: 'Image must be in PNG, JPG, or WEBP format',
                uploadingImage: 'Uploading image...',
                imageUploadSuccess: 'Image updated successfully',
                jobTitleUpdateSuccess: 'Job title updated successfully',
                jobTitleUpdateFailed: 'Failed to update job title',
                bioUpdateSuccess: 'Bio updated successfully',
                bioUpdateFailed: 'Failed to update bio',
                selectJobTitle: 'Select Job Title',
                jobTitleRequired: 'Please select a job title',
                enterBio: 'Enter your bio',
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                yearsAgo: '{years} years ago',
                editJobTitle: 'Edit Job Title',
                editAbout: 'Edit About Me',
                personalBio: 'Personal Bio',
                bioPlaceholder: 'Write a brief bio about yourself, your experience and skills...',
                bioMaxLength: 'Maximum 2000 characters',
                addWorkExperience: 'Add Work Experience',
                editWorkExperience: 'Edit Work Experience',
                companyName: 'Company Name',
                companyNamePlaceholder: 'Enter company name',
                fromDate: 'From Date',
                toDate: 'To Date',
                toDateHint: 'Leave empty for current job',
                description: 'Description',
                descriptionPlaceholder: 'Write a brief description of your responsibilities and achievements (optional)',
                fillAllRequired: 'Please fill all required fields',
                endDateAfterStart: 'End date must be after start date',
                workExperienceAdded: 'Work experience added successfully',
                workExperienceAddFailed: 'Failed to add work experience',
                workExperienceUpdated: 'Work experience updated successfully',
                workExperienceUpdateFailed: 'Failed to update work experience',
                workExperienceNotFound: 'Work experience not found',
                workExperienceDeleted: 'Work experience deleted successfully',
                workExperienceDeleteFailed: 'Failed to delete work experience',
                saveChanges: 'Save Changes',
                from: 'From',
                until: 'Until',
                untilNow: 'Until Now',
                addEducation: 'Add Certificate',
                editEducation: 'Edit Certificate',
                educationHistory: 'Certificates',
                academicDegree: 'Academic Degree',
                academicDegreePlaceholder: 'Example: Bachelor, Master, PhD',
                educationAuthority: 'University / Educational Institution Name',
                educationAuthorityPlaceholder: 'Enter university or educational institution name',
                specialization: 'Specialization',
                specializationPlaceholder: 'Example: Computer Science, Business Administration',
                grade: 'Grade / GPA',
                gradePlaceholder: 'Example: Excellent, Very Good, 3.5/4',
                graduationDate: 'Graduation Date',
                educationAdded: 'Certificate added successfully',
                educationAddFailed: 'Failed to add certificate',
                educationUpdated: 'Certificate updated successfully',
                educationUpdateFailed: 'Failed to update certificate',
                educationNotFound: 'Certificate not found',
                educationDeleted: 'Certificate deleted successfully',
                educationDeleteFailed: 'Failed to delete certificate',
                noEducationRecorded: 'No certificates recorded',
                replaceCv: 'Replace CV',
                uploadCvButton: 'Upload CV',
                noCvText: 'No CV uploaded',
                deleteConfirmTitle: 'Are you sure?',
                deleteConfirmText: 'Are you sure you want to delete this item?',
                deleteConfirmButton: 'Yes, delete',
                deleteCancelButton: 'Cancel',
                deleteSuccessTitle: 'Success!',
                deleteSuccessText: 'Deleted successfully',
                deleteFailedTitle: 'Error!',
                deleteFailedText: 'Failed to delete',
            },
            editProfile: {
                title: 'Edit Profile',
                phone: 'Phone Number',
                phonePlaceholder: 'Enter phone number',
                phoneRequired: 'Phone number is required',
                email: 'Email',
                emailPlaceholder: 'Enter email',
                emailRequired: 'Email is required',
                emailInvalid: 'Invalid email format',
                save: 'Save',
                saving: 'Saving...',
                updateSuccess: 'Profile updated successfully',
                updateFailed: 'Failed to update profile',
                loadFailed: 'Failed to load data',
                uploadingImage: 'Uploading image...',
                imageUploadSuccess: 'Image updated successfully',
                imageUploadFailed: 'Failed to upload image',
            },
            notifications: {
                title: 'Notifications',
                loadFailed: 'Failed to load notifications',
                noNotifications: 'No notifications',
                markAllAsRead: 'Mark all as read',
                allMarkedAsRead: 'All notifications marked as read',
                loadMore: 'Load More',
            },
            settings: {
                editCompanyProfile: 'Edit Company Profile',
                title: 'Settings',
                editAccount: 'Edit My Account',
                changePassword: 'Change Password',
                aboutApp: 'About App',
                termsOfUse: 'Terms of Use',
                contactUs: 'Contact Us',
                deleteAccount: 'Delete Account',
                logout: 'Logout',
                changePasswordTitle: 'Change Password',
                currentPassword: 'Current Password',
                currentPasswordPlaceholder: 'Enter current password',
                currentPasswordRequired: 'Please enter current password',
                newPassword: 'New Password',
                newPasswordPlaceholder: 'Enter new password',
                newPasswordRequired: 'Please enter new password',
                newPasswordMinLength: 'Password must be at least 8 characters',
                confirmPassword: 'Confirm Password',
                confirmPasswordPlaceholder: 'Re-enter new password',
                confirmPasswordMismatch: 'New password and confirmation do not match',
                passwordHint: 'Must be at least 8 characters',
                save: 'Save',
                cancel: 'Cancel',
                passwordChangeSuccess: 'Password changed successfully',
                passwordChangeFailed: 'Failed to change password',
                aboutAppTitle: 'About App',
                aboutAppDescription: 'Tawzeef is an integrated platform connecting job seekers with companies and recruitment agencies.',
                appVersion: 'App Version: 1.0.0',
                allRightsReserved: 'All rights reserved © 2024',
                ok: 'OK',
                termsTitle: 'Terms of Use',
                termsContent: {
                    acceptance: '1. Acceptance: By using this app, you agree to comply with these terms of use.',
                    allowedUse: '2. Allowed Use: The app must be used for legal purposes only and in accordance with applicable laws.',
                    privacy: '3. Privacy: We are committed to protecting your data privacy in accordance with our privacy policy.',
                    liability: '4. Liability: We are not responsible for any damages that may result from using the app.',
                    modifications: '5. Modifications: We reserve the right to modify these terms at any time without prior notice.',
                },
                contactTitle: 'Contact Us',
                email: 'Email:',
                phone: 'Phone:',
                address: 'Address:',
                addressValue: 'Saudi Arabia',
                deleteAccountTitle: 'Are you sure you want to delete your account?',
                deleteAccountWarning: 'You will not be able to undo this action. All your data will be permanently deleted.',
                deleteAccountButton: 'Delete Account',
                deleteAccountInfo: 'Account deletion feature coming soon',
                deleteAccountFailed: 'Failed to delete account',
                logoutTitle: 'Are you sure you want to logout?',
                logoutButton: 'Logout',
                logoutSuccess: 'Logged out successfully',
                changeLanguage: 'Change Language',
                languageChanged: 'Language changed successfully',
                currentLanguage: 'Current Language',
                selectLanguage: 'Select Language',
            },
            navigation: {
                home : 'Home',
                saved : 'Saved',
                applications : 'Applications',
                profile : 'Profile',
            }
        },
        company: {
            settings: {
                title: 'Settings',
                editAccount: 'Edit Company Data',
                manageUsers: 'Manage Company Users',
                changePassword: 'Change Password',
                editMyAccount: 'Edit My Account',
                logout: 'Logout',
                changePasswordTitle: 'Change Password',
                currentPassword: 'Current Password',
                currentPasswordPlaceholder: 'Enter current password',
                currentPasswordRequired: 'Please enter current password',
                newPassword: 'New Password',
                newPasswordPlaceholder: 'Enter new password',
                newPasswordRequired: 'Please enter new password',
                newPasswordMinLength: 'Password must be at least 8 characters',
                confirmPassword: 'Confirm Password',
                confirmPasswordPlaceholder: 'Re-enter new password',
                confirmPasswordMismatch: 'New password and confirmation do not match',
                passwordHint: 'Must be at least 8 characters',
                save: 'Save',
                cancel: 'Cancel',
                passwordChangeSuccess: 'Password changed successfully',
                passwordChangeFailed: 'Failed to change password',
                logoutTitle: 'Are you sure you want to logout?',
                logoutButton: 'Logout',
                logoutSuccess: 'Logged out successfully',
                changeLanguage: 'Change Language',
                languageChanged: 'Language changed successfully',
                currentLanguage: 'Current Language',
                selectLanguage: 'Select Language',
                arabic: 'العربية',
                english: 'English',
                deleteAccount: 'Delete Account',
                deleteAccountTitle: 'Are you sure you want to delete your account?',
                deleteAccountWarning: 'You will not be able to undo this action. All your data will be permanently deleted.',
                deleteAccountButton: 'Delete Account',
                deleteAccountInfo: 'Account deletion feature coming soon',
                deleteAccountFailed: 'Failed to delete account',
            },
            createVacancy: {
                title: 'Create New Vacancy',
                subtitle: 'Add details for the new vacancy',
                basicInfo: 'Basic Information',
                jobTitle: 'Job Title',
                jobTitleRequired: 'Job title is required',
                selectJobTitle: 'Select job title',
                workType: 'Work Type',
                selectType: 'Select type',
                presenceType: 'Presence Type',
                experience: 'Years of Experience',
                academicDegree: 'Academic Degree',
                academicDegreePlaceholder: 'Example: Bachelor',
                salaryLocation: 'Salary & Location',
                salary: 'Salary',
                currency: 'Currency',
                currencyPlaceholder: 'EGP',
                latitude: 'Latitude',
                longitude: 'Longitude',
                details: 'Details',
                description: 'Description',
                descriptionPlaceholder: 'Write a detailed description of the vacancy...',
                privileges: 'Benefits and Privileges',
                privilegesPlaceholder: 'Write the benefits and privileges offered...',
                status: 'Status',
                open: 'Open',
                closed: 'Closed',
                cancel: 'Cancel',
                create: 'Create Vacancy',
                creating: 'Creating...',
                createSuccess: 'Vacancy created successfully!',
                createFailed: 'Failed to create vacancy',
                USD: 'USD',
                EGP : 'EGP',
                EUR : 'EUR',
                skills: 'Skills',
                skillsDescription: 'Select the required skills for this vacancy',
                noSkillsAvailable: 'No skills available',
            },
            vacancyManagement: {
                title: 'Vacancy Management',
                subtitle: 'Manage all published vacancies',
                createNew: 'Create New Vacancy',
                noVacancies: 'You haven\'t created any vacancies yet',
                loadFailed: 'Failed to load vacancies',
                deleteConfirm: 'Are you sure you want to delete this vacancy?',
                deleteWarning: 'You will not be able to undo this action.',
                delete: 'Delete',
                deleteSuccess: 'Vacancy deleted successfully',
                deleteFailed: 'Failed to delete vacancy',
                open: 'Open',
                closed: 'Closed',
                notSpecified: 'Not specified',
                viewDetails: 'View Details',
                viewApplications: 'View Applications',
            },
            profile: {
                title: 'Company Information',
                loadFailed: 'Failed to load company profile',
                name: 'Company Name',
                bio: 'Company Bio',
                noBio: 'No company bio added yet.',
                address: 'Address',
                website: 'Website',
                email: 'Email',
                phone: 'Phone',
                employeesCount: 'Employees Count',
                image: 'Company Image',
                pdf: 'Company PDF',
                viewPdf: 'View PDF',
                view: 'View',
                edit: 'Edit',
                clickToView: 'Click to view',
                noPdf: 'No PDF added yet.',
            },
            editProfile: {
                title: 'Edit Company Data',
                subtitle: 'Keep your information updated for easy communication',
                name: 'Company Name',
                nameRequired: 'Company name is required',
                bio: 'Company Bio',
                bioPlaceholder: 'Brief description about the company',
                address: 'Address',
                website: 'Website',
                email: 'Email',
                emailRequired: 'Email is required',
                emailInvalid: 'Invalid email format',
                phone: 'Phone',
                employeesCount: 'Employees Count',
                image: 'Company Image',
                pdf: 'Company PDF',
                pdfHint: 'PDF files only (max 10MB)',
                pdfInvalid: 'Please upload a PDF file',
                pdfSizeError: 'PDF file size must not exceed 10MB',
                pdfSelected: 'Selected',
                viewCurrentPdf: 'View Current PDF',
                currentPdf: 'Current PDF',
                clickToView: 'Click to view',
                view: 'View',
                uploadPdf: 'Upload PDF Document',
                dragDropPdf: 'Drag & drop your PDF here, or click to browse',
                remove: 'Remove',
                save: 'Save Changes',
                saving: 'Saving...',
                saveSuccess: 'Data updated successfully',
                saveFailed: 'Failed to update data',
                uploadImage: 'Upload Image',
                changeImage: 'Change Image',
            },
            notifications: {
                title: 'Notifications',
                loadFailed: 'Failed to load notifications',
                noNotifications: 'No notifications',
                markAllAsRead: 'Mark all as read',
                allMarkedAsRead: 'All notifications marked as read',
                loadMore: 'Load More',
            },
            vacancyDetail: {
                title: 'Vacancy Details',
                edit: 'Edit',
                delete: 'Delete',
                applications: 'Applications',
                status: 'Status',
                open: 'Open',
                closed: 'Closed',
                notFound: 'Vacancy not found',
                backToList: 'Back to List',
                loadFailed: 'Failed to load vacancy details',
                description: 'Description',
                details: 'Details',
                skills: 'Required Skills',
                jobInformation: 'Job Information',
                jobTitle: 'Job Title',
                academicDegree: 'Academic Degree',
                experience: 'Experience',
                workType: 'Work Type',
                presenceType: 'Presence Type',
                salary: 'Salary',
                company: 'Company',
                applicationsTab: 'Applications',
                descriptionTab: 'Job Description',
                noApplications: 'No applications yet',
                applicationsCount: 'There are {count} applications for this vacancy',
                viewAllApplications: 'View All Applications',
            },
            editVacancy: {
                title: 'Edit Vacancy',
                subtitle: 'Update vacancy details',
                update: 'Update Vacancy',
                updating: 'Updating...',
                updateSuccess: 'Vacancy updated successfully',
                updateFailed: 'Failed to update vacancy',
            },
            vacancyApplications: {
                title: 'Job Applications',
                noApplications: 'No applications',
                loadFailed: 'Failed to load applications',
                applicant: 'Applicant',
                appliedDate: 'Applied Date',
                status: 'Status',
                actions: 'Actions',
                view: 'View',
                accept: 'Accept',
                reject: 'Reject',
                pending: 'Pending',
                accepted: 'Accepted',
                rejected: 'Rejected',
                viewProfile: 'View Profile',
            },
            users: {
                title: 'Company Users',
                createNew: 'Add New User',
                noUsers: 'No users',
                loadFailed: 'Failed to load users',
                name: 'Name',
                email: 'Email',
                role: 'Role',
                actions: 'Actions',
                edit: 'Edit',
                delete: 'Delete',
            },
            userCreate: {
                title: 'Add New User',
                name: 'Name',
                nameRequired: 'Name is required',
                email: 'Email',
                emailRequired: 'Email is required',
                emailInvalid: 'Invalid email format',
                password: 'Password',
                passwordRequired: 'Password is required',
                passwordMinLength: 'Password must be at least 8 characters',
                role: 'Role',
                roleRequired: 'Role is required',
                create: 'Create',
                creating: 'Creating...',
                createSuccess: 'User created successfully',
                createFailed: 'Failed to create user',
            },
            userEdit: {
                title: 'Edit User',
                update: 'Update',
                updating: 'Updating...',
                updateSuccess: 'User updated successfully',
                updateFailed: 'Failed to update user',
            },
            plans: {
                title: 'Plans',
                subtitle: 'Subscription Plans',
                subtitleDescription: 'Choose the right plan for your company',
                loadFailed: 'Failed to load plans',
                subscribe: 'Subscribe',
                subscribeNow: 'Subscribe Now',
                subscribing: 'Subscribing...',
                subscribeSuccess: 'Successfully subscribed',
                subscribeFailed: 'Failed to subscribe',
                currentPlan: 'Current Plan',
                noPlansAvailable: 'No plans available currently',
                planName: 'Plan',
                duration: 'Duration',
                durationDays: 'days',
                vacanciesLimit: 'Number of Vacancies',
                clientsLimit: 'Clients',
                unlimited: 'Unlimited',
            },
            subscriptions: {
                title: 'subscriptions',
                noSubscriptions: 'No subscriptions',
                loadFailed: 'Failed to load subscriptions',
                cancelSuccess : 'Subscription canceled successfully',
                cancelFailed : 'Failed to cancel subscription',
                title : 'Subscriptions',
                subtitle : 'Subscriptions',
                allSubscriptions : 'All Subscriptions',
                active : 'Active',
                canceled : 'Canceled',
                expired : 'Expired',
                noSubscriptions : 'No subscriptions',
                plan : 'Plan',
                price : 'Price',
                status : 'Status',
                startDate : 'Start Date',
                endDate : 'End Date',
                actions : 'Actions',
                subscription : 'Subscription',
                cancelling : 'Cancelling',
                cancelSubscription : 'Cancel Subscription',
            },
            subscriptionDetail: {
                title: 'Subscription Details',
                loadFailed: 'Failed to load subscription details',
            },
            navigation: {
                vacancies: 'Vacancies',
                subscriptions: 'Subscriptions',
                addVacancy: 'Add Vacancy',
                plans: 'Plans',
                profile: 'Profile',
            },
            nav: {
                company: 'Company',
                recruitmentCompany: 'Recruitment Company',
            },
        },
    },
};

// Get current locale from localStorage or default to 'ar'
export const getLocale = () => {
    return localStorage.getItem('locale') || 'ar';
};

// Set locale
export const setLocale = (locale) => {
    localStorage.setItem('locale', locale);
    window.dispatchEvent(new Event('localechange'));
};

// Get translation
export const t = (key, locale = null) => {
    const currentLocale = locale || getLocale();

    // Check if locale exists
    if (!translations[currentLocale]) {
        console.warn(`Locale "${currentLocale}" not found, falling back to "ar"`);
        return t(key, 'ar');
    }

    const keys = key.split('.');
    let value = translations[currentLocale];

    for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            // Fallback to Arabic if translation not found
            if (currentLocale !== 'ar') {
                return t(key, 'ar');
            }
            // If already in Arabic and not found, return key
            console.warn(`Translation key "${key}" not found in locale "${currentLocale}"`);
            return key;
        }
    }

    return typeof value === 'string' ? value : key;
};


// Export translations for direct access if needed
export default translations;

